import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { ChevronDown } from 'lucide-react';
export function Pricing() {
  const [expandedCard, setExpandedCard] = useState<'standard' | 'recommended' | null>('recommended');
  const toggleCard = (card: 'standard' | 'recommended') => {
    setExpandedCard(expandedCard === card ? null : card);
  };
  return <section className="bg-white py-4 md:py-24 px-4 min-h-[100svh] md:min-h-0 flex flex-col justify-center" id="pricing" data-id="element-335">
      <div className="max-w-6xl mx-auto text-center w-full flex flex-col h-full justify-between md:justify-center py-4" data-id="element-336">
        <div data-id="element-337">
          <p className="text-sage font-sans font-medium tracking-[2px] md:text-sm mb-1 md:mb-12 uppercase text-[14px]" data-id="element-338">
            ELEGÍ TU COLECCIÓN
          </p>

          <div className="w-full max-w-md mx-auto mb-2 md:mb-16" data-id="element-339">
            <p className="text-sage font-sans font-bold md:text-xs tracking-widest mb-1 md:mb-4 uppercase text-[12px]" data-id="element-340">
              ⏰ CIERRA EN:
            </p>
            <div className="scale-[0.55] md:scale-100 origin-center -my-4 md:my-0" data-id="element-341">
              <CountdownTimer variant="pricing" data-id="element-342" />
            </div>
          </div>
        </div>

        <div className="flex flex-col md:grid md:grid-cols-2 gap-3 md:gap-8 items-stretch" data-id="element-343">
          {/* Standard Card */}
          <div className={`bg-white p-4 md:p-10 rounded-xl border-2 transition-all duration-300 ${expandedCard === 'standard' ? 'border-sage shadow-md' : 'border-sage-light/30 shadow-sm'} text-left flex flex-col`} data-id="element-344">
            <div className="flex justify-between items-center md:block cursor-pointer" onClick={() => toggleCard('standard')} data-id="element-345">
              <div data-id="element-346">
                <p className="text-sage font-sans font-bold text-[11px] md:text-sm md:mb-8" data-id="element-347">
                  💛 COLECCIÓN BASE
                </p>
                <button className="md:hidden flex items-center gap-1 text-[10px] text-sage font-bold mt-1 uppercase tracking-wider" data-id="element-348">
                  {expandedCard === 'standard' ? 'Ocultar detalles' : 'Ver detalles'}
                  <ChevronDown size={12} className={`transition-transform duration-300 ${expandedCard === 'standard' ? 'rotate-180' : ''}`} data-id="element-349" />
                </button>
              </div>
              <div className="text-right" data-id="element-350">
                <p className="text-taupe line-through text-[10px] md:text-lg leading-none md:mb-1" data-id="element-351">
                  $47.000
                </p>
                <p className="font-display font-bold text-navy text-[18px] md:text-[48px] leading-tight" data-id="element-352">
                  $19.990 ARS
                </p>
              </div>
            </div>

            <AnimatePresence data-id="element-353">
              {(expandedCard === 'standard' || window.innerWidth >= 768) && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden md:!h-auto md:!opacity-100" data-id="element-354">
                  <ul className="space-y-3 md:space-y-4 my-4 md:mb-12 flex-grow border-t border-sage-light/20 pt-4 md:border-0 md:pt-0" data-id="element-355">
                    {['30 módulos completos', 'Kit 2 AM Rescate', 'Planner Cierre Día', 'Acceso PDF', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-center gap-2 text-[#2D2D2D] font-sans text-[12px] md:text-sm" data-id="element-356">
                        <span className="text-sage" data-id="element-357">✓</span> {item}
                      </li>)}
                  </ul>
                </motion.div>}
            </AnimatePresence>

            <motion.a href="https://checkout2.guiadigital360.online/cart/44370674221149:1" animate={{
            scale: [1, 1.03, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.05,
            backgroundColor: '#2D4033'
          }} whileTap={{
            scale: 0.98
          }} className="bg-sage text-cream-white font-sans font-bold py-3 md:py-[18px] px-4 md:px-[40px] rounded-full text-center text-[13px] md:text-base mt-auto" data-id="element-358">
              → QUIERO MI COLECCIÓN
            </motion.a>
          </div>

          {/* Recommended Card */}
          <div className={`bg-sage p-4 md:p-10 rounded-xl border-[2px] md:border-[3px] transition-all duration-300 ${expandedCard === 'recommended' ? 'border-gold shadow-sage-heavy' : 'border-gold/30 shadow-md'} text-left relative flex flex-col`} data-id="element-359">
            <div className="absolute -top-2.5 left-4 bg-gold text-sage-dark font-sans font-bold py-0.5 px-2 rounded-full text-[8px] md:text-xs uppercase tracking-widest whitespace-nowrap" data-id="element-360">
              ⭐ RECOMENDADO
            </div>

            <div className="flex justify-between items-center md:block mt-1 cursor-pointer" onClick={() => toggleCard('recommended')} data-id="element-361">
              <div data-id="element-362">
                <p className="text-gold font-display font-bold text-[11px] md:text-xl md:mb-8" data-id="element-363">
                  💛 COLECCIÓN + PROTOCOLO
                </p>
                <button className="md:hidden flex items-center gap-1 text-[10px] text-gold font-bold mt-1 uppercase tracking-wider" data-id="element-364">
                  {expandedCard === 'recommended' ? 'Ocultar detalles' : 'Ver detalles'}
                  <ChevronDown size={12} className={`transition-transform duration-300 ${expandedCard === 'recommended' ? 'rotate-180' : ''}`} data-id="element-365" />
                </button>
              </div>
              <div className="text-right" data-id="element-366">
                <p className="text-cream-white/50 line-through text-[10px] md:text-lg leading-none md:mb-1" data-id="element-367">
                  $69.000
                </p>
                <p className="font-display font-bold text-gold text-[20px] md:text-[52px] leading-tight" data-id="element-368">
                  $24.990 ARS
                </p>
              </div>
            </div>

            <AnimatePresence data-id="element-369">
              {(expandedCard === 'recommended' || window.innerWidth >= 768) && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden md:!h-auto md:!opacity-100" data-id="element-370">
                  <div className="my-4 border-t border-gold/20 pt-4 md:border-0 md:pt-0" data-id="element-371">
                    <p className="text-cream-white/70 font-sans text-[10px] md:text-sm mb-3 uppercase tracking-wider" data-id="element-372">
                      TODO LO DE LA COLECCIÓN +
                    </p>
                    <ul className="space-y-3 md:space-y-4 md:mb-12 flex-grow" data-id="element-373">
                      {['Protocolo 90 Días', '4 Pilares de transformación', 'El Escudo de Mañana', 'Trackers mensuales', 'Biblioteca de 20 casos'].map((item, i) => <li key={i} className="flex items-center gap-2 text-cream-white font-sans text-[12px] md:text-sm" data-id="element-374">
                          <span className="text-gold" data-id="element-375">✓</span> {item}
                        </li>)}
                    </ul>
                  </div>
                </motion.div>}
            </AnimatePresence>

            <motion.a href="https://checkout2.guiadigital360.online/cart/44370707284061:1" animate={{
            scale: [1, 1.03, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.05,
            backgroundColor: '#C4956A'
          }} whileTap={{
            scale: 0.98
          }} className="bg-gold text-sage-dark font-sans font-bold py-3 md:py-[18px] px-4 md:px-[40px] rounded-full text-center text-[13px] md:text-base mt-auto" data-id="element-376">
              → QUIERO LA COMPLETA
            </motion.a>

            <p className="text-gold/80 font-sans font-medium text-[8px] md:text-sm mt-2 text-center" data-id="element-377">
              ⚠️ Después sube $8.000 ARS.
            </p>
          </div>
        </div>
      </div>
    </section>;
}